import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import holidays from '@/components/layout/holidays';

/**
 * Check if a date falls within a holiday period
 * @param {Date} date - The date to check
 * @param {Object} startDate - Start date object { day, month, year }
 * @param {Object} endDate - End date object { day, month, year }
 * @returns {boolean}
 */
function isDateInRange(date, startDate, endDate) {
  var currentYear = date.getFullYear();
  var currentMonth = date.getMonth() + 1; // JavaScript months are 0-indexed
  var currentDay = date.getDate();
  var startMonth = startDate.month;
  var startDay = startDate.day;
  var startYear = startDate.year; // Can be null for recurring holidays

  var endMonth = endDate.month;
  var endDay = endDate.day;
  var endYear = endDate.year; // Can be null for recurring holidays

  // If years are specified, check if current year matches
  if (startYear !== null && currentYear < startYear) {
    return false;
  }
  if (endYear !== null && currentYear > endYear) {
    return false;
  }

  // If years are specified and different, handle multi-year ranges
  if (startYear !== null && endYear !== null && startYear !== endYear) {
    // Multi-year range
    if (currentYear > startYear && currentYear < endYear) {
      return true; // Within the year range
    }
    if (currentYear === startYear) {
      // Check if after start date in start year
      if (currentMonth > startMonth) return true;
      if (currentMonth === startMonth && currentDay >= startDay) return true;
      return false;
    }
    if (currentYear === endYear) {
      // Check if before end date in end year
      if (currentMonth < endMonth) return true;
      if (currentMonth === endMonth && currentDay <= endDay) return true;
      return false;
    }
    return false;
  }

  // Handle date ranges within the same year (or recurring yearly)
  if (startMonth <= endMonth) {
    // Simple case: start and end are in the same year progression
    if (currentMonth < startMonth || currentMonth > endMonth) {
      return false;
    }
    if (currentMonth === startMonth && currentDay < startDay) {
      return false;
    }
    if (currentMonth === endMonth && currentDay > endDay) {
      return false;
    }
    return true;
  } else {
    // Handle date ranges that span year boundary (e.g., Dec 15 - Jan 15)
    if (currentMonth > endMonth && currentMonth < startMonth) {
      return false;
    }
    if (currentMonth === startMonth && currentDay < startDay) {
      return false;
    }
    if (currentMonth === endMonth && currentDay > endDay) {
      return false;
    }
    return true;
  }
}

/**
 * Get the currently active holiday based on today's date
 * @param {Date} date - Optional date to check (defaults to today)
 * @returns {Object|null} - The active holiday config or null
 */
export function getActiveHoliday() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  var holidayList = Object.values(holidays);
  console.log({
    holidayList: holidayList
  });
  for (var _i = 0, _holidayList = holidayList; _i < _holidayList.length; _i++) {
    var holiday = _holidayList[_i];
    console.log({
      holiday: holiday
    });
    if (isDateInRange(date, holiday.startDate, holiday.endDate)) {
      return holiday;
    }
  }
  return null;
}

/**
 * Get holiday configuration by ID
 * @param {string} holidayId - The holiday ID
 * @returns {Object|null} - The holiday config or null
 */
export function getHolidayById(holidayId) {
  return holidays[holidayId] || null;
}

/**
 * Check if a specific holiday is currently active
 * @param {string} holidayId - The holiday ID to check
 * @param {Date} date - Optional date to check (defaults to today)
 * @returns {boolean}
 */
export function isHolidayActive(holidayId) {
  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  var holiday = getHolidayById(holidayId);
  if (!holiday) {
    return false;
  }
  return isDateInRange(date, holiday.startDate, holiday.endDate);
}

/**
 * Check if a theme is a holiday theme and if that holiday is still active
 * @param {string} themeCode - The theme code to check
 * @param {Date} date - Optional date to check (defaults to today)
 * @returns {boolean} - True if theme is valid (not a holiday theme, or holiday is active)
 */
export function isThemeValid(themeCode) {
  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  // Check if this theme code matches any holiday theme
  var holidayList = Object.values(holidays);
  var matchedHoliday = holidayList.find(function (h) {
    return h.theme === themeCode;
  });

  // If it's not a holiday theme, it's always valid
  if (!matchedHoliday) {
    return true;
  }

  // If it is a holiday theme, check if the holiday is currently active
  return isDateInRange(date, matchedHoliday.startDate, matchedHoliday.endDate);
}

/**
 * Get all holidays
 * @returns {Object} - All holiday configurations
 */
export function getAllHolidays() {
  return holidays;
}

// Nuxt plugin
export default function (_ref, inject) {
  _objectDestructuringEmpty(_ref);
  // Inject $holiday helper into the app
  inject('holiday', {
    getActive: getActiveHoliday,
    getById: getHolidayById,
    isActive: isHolidayActive,
    isThemeValid: isThemeValid,
    getAll: getAllHolidays
  });
}